import { ItemList } from '../orm'
import { get, head, size, map, filter, forEach } from 'lodash'

class CurrencyList extends ItemList {
    getEntityKey() {
        return "country"
    }

    getForCountry({country_2_digit_code}) {
        return head(filter(this.getObjects(), (currency) => currency.country_2_digit_code ===country_2_digit_code))
    }
    
    ensureLoadedForCountry({country_2_digit_code}) {
        return (dispatch, getState) => {
            dispatch(this.updateListFilter({country_2_digit_code}))
            dispatch(this.fetchListIfNeeded())
        }
    }
}

export const currencyList = new CurrencyList("currency_list_default")